import React, { Fragment } from 'react'
import classNames from 'classnames'

import PassengerSSRWithSSROriginalSSRInterface from '../../interfaces/client/PassengerSSRWithSSROriginalSSR'

import SSRTag from '../SSRTag'

import styles from './PassengerSSRs.module.scss'

interface PassengerSSRsPropsInterface {
  removeSSR: Function
  removeNotification: Function
  setPassengerSSRToDelete: Function
  unsetPassengerSSRToDelete: Function

  passengerId: string
  passengerSSRs: PassengerSSRWithSSROriginalSSRInterface[]
  errorMessages: string[]
  errorIds: string[]

  isPassengerCheckedIn?: boolean

  isDisabled: boolean
  readonly: boolean
  hasError: boolean
  startOnColumnThree: boolean
}

export default (props: PassengerSSRsPropsInterface) => {
  const {
    passengerId,
    passengerSSRs,
    removeSSR,
    isDisabled,
    readonly,
    errorMessages,
    errorIds,
    hasError,
    startOnColumnThree,
    setPassengerSSRToDelete,
    unsetPassengerSSRToDelete,
    removeNotification,
    isPassengerCheckedIn = false,
  } = props

  if (!passengerSSRs.length) return null

  const removeNotifications = () => {
    if (hasError) {
      errorIds.forEach((errorId: string) => {
        removeNotification(errorId)
      })
    }
  }

  return (
    <Fragment>
      <ul
        className={classNames(styles['wrapper'], {
          [styles['wrapper--on-edit']]: startOnColumnThree,
        })}
      >
        {passengerSSRs.map((ssr: PassengerSSRWithSSROriginalSSRInterface) => (
          <SSRTag
            key={ssr.passengerSSRId}
            ssr={ssr.ssr}
            isNew={readonly ? false : !ssr.isConfirmed}
            hasError={hasError}
            isAddedByTourOperator={ssr.isAbleToDelete}
            onDestroy={() => {
              removeNotifications()
              ssr.isConfirmed
                ? setPassengerSSRToDelete(passengerId, ssr.passengerSSRId)
                : removeSSR(passengerId, ssr.passengerSSRId)
            }}
            isDisabled={isDisabled || isPassengerCheckedIn}
            toDelete={ssr.toDelete}
            onReset={() => {
              removeNotifications()
              unsetPassengerSSRToDelete(passengerId, ssr.passengerSSRId)
            }}
          />
        ))}
      </ul>

      {hasError && (
        <div
          className={classNames(styles['errors'], {
            [styles['errors--on-edit']]: startOnColumnThree,
          })}
        >
          {errorMessages.map((errorMessage: string) => (
            <p
              className={styles['error']}
              data-error="ssr-error-message"
              key={errorMessage}
            >
              {errorMessage}
            </p>
          ))}
        </div>
      )}
    </Fragment>
  )
}
